// ==============================================
// ================Import Reducers================
// ==============================================

import { combineReducers } from 'redux';
import metadataReducer from './metadata';

import siteReducer from './site';
import dataAPIReducer from './dataAPI';
import multipleMetadataReducer from './multipleMetadata';
import filesReducer from './files';
import headerReducer from './header';
import menuButtonReducer from './menuButton';
import networkReducer from './network';
import nodeInfoReducer from './nodeInfo';
import footerReducer from './footer';
import personalizedReducer from './personalized';
import popupCookieReducer from './popupCookie';

const rootReducer = combineReducers({
  site: siteReducer,
  metadata: metadataReducer,
  dataAPI: dataAPIReducer,
  multipleMetadata: multipleMetadataReducer,
  files: filesReducer,
  header: headerReducer,
  menuButton: menuButtonReducer,
  network: networkReducer,
  nodeInfo: nodeInfoReducer,
  footer: footerReducer,
  personalized: personalizedReducer,
  popupCookie: popupCookieReducer,

});

export default rootReducer;
